export default "__VITE_ASSET__B63SFLkE__"